import * as React from 'react';
import {Redirect, Route} from "react-router";
import Layout from "./components/Layout";

import { CCAViewer } from "./components/CCAViewer";



export default () => {

  let customerTelephoneNumber = "01603 218000";
  let customerTelephoneNumber44 = "+441603218000";

  function setCustomerTelephoneNumber(tel: string) {
    customerTelephoneNumber = tel;
    customerTelephoneNumber44 = "+44" + tel.replace(" ", "").slice(1);
    //console.log("telephone changed to " + tel);
  }

  //console.log("RENDER DEFAULT", customerTelephoneNumber);
  return (
    <Layout customerTelephoneNo={customerTelephoneNumber} customerTelephoneNo44={customerTelephoneNumber44} >
      <Route exact path="/">
        <Redirect to="/myagreement/" />
      </Route>
      <Route exact path='/myagreement/:uniqueRef?' render={(props) => <CCAViewer setCustomerTelephoneNo={setCustomerTelephoneNumber} {...props} />} />
    </Layout>);
};
